import type { ComponentProps } from "react";
import { type Control, type FieldPath, useController } from "react-hook-form";
import type { FieldValues } from "react-hook-form/dist/types/fields";
import { FormGroup } from "@/components/form/FormGroup";
import { Textarea } from "@/components/form/Textarea";

interface TextareaFieldProps<TFieldValues extends FieldValues>
  extends Omit<
    ComponentProps<typeof Textarea>,
    keyof ReturnType<typeof useController>["field"]
  > {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  required?: boolean;
}

export function TextareaField<TFieldValues extends FieldValues>(
  props: TextareaFieldProps<TFieldValues>,
) {
  const { control, name, label, id, required, ...rest } = props;
  const { field, fieldState } = useController({ control, name });

  return (
    <FormGroup
      label={label}
      htmlFor={name}
      error={fieldState.error?.message}
      required={required}
    >
      <Textarea id={name} {...field} {...rest} />
    </FormGroup>
  );
}
